let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5J0Wb")).then(() => parcelRequire('a6h8L'));